
// src/components/home/SocialLinks.jsx
import React from 'react';
import youtubeImg from '../../assets/images/youtube.png';
import spotifyImg from '../../assets/images/spotify.png';
import emailImg from '../../assets/images/email.png';

const SocialLinks = () => {
  const socialLinks = [
    { name: 'Spotify', imgSrc: spotifyImg, icon: 'spotify', url: 'https://open.spotify.com/artist/7AYhTfbPaA9sij7vbJpa2u?si=zru1jFQ5Q62VUyK9vslEgw', color: 'bg-green-600' },
    { name: 'YouTube', imgSrc: youtubeImg, icon: 'youtube', url: 'https://www.youtube.com/@EsbjornFalk', color: 'bg-red-600' },
    { name: 'Email', imgSrc: emailImg, icon: 'email', url: 'mailto::mail@esbjornfalk.com', color: 'bg-red-600' },

  ];
  
  // This is a placeholder for social icons - in a real app you'd use proper icons
  const getIcon = (icon) => {
    switch (icon) {
      case 'spotify':
        return 'S';
      case 'apple':
        return 'A';
      case 'youtube':
        return 'Y';
      case 'instagram':
        return 'I';
      case 'facebook':
        return 'F';
      default:
        return '';
    }
  };
  
  return (
    <div className="flex flex-wrap gap-4">
      {socialLinks.map((link) => (
        <a 
          key={link.name}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center space-x-2 px-4 py-2 rounded-full bg-gray-800 hover:bg-gray-700 transition-colors"
        >
            <img className='h-10'
            src={link.imgSrc}></img>
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;